var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-12"},[_c('div',[_vm._v(" "+_vm._s(_vm.data.title)+" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.description)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }